import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { create, parseCreationOptionsFromJSON, get, parseRequestOptionsFromJSON } from '@github/webauthn-json/browser-ponyfill';
import { lastValueFrom } from 'rxjs';
import { environmentConfig } from '../../environment';

@Injectable({ providedIn: 'root' })
export class YubikeyService {
  authURLBase = environmentConfig.apiAuthBaseUrl;

  constructor(private http: HttpClient) {}

  async enrollYubikey(username: string, keyname:string) {
    try {
      // STEP 1: Get Registration Options from your C# Controller
      const options = await lastValueFrom(
        this.http.post<any>(this.authURLBase + '/api/FIDO/register-options?username=' + username, null)
      );
      console.log("options from FIDO service", options);
      
      // STEP 2: Trigger the Browser/YubiKey prompt
      // converts the JSON options into the binary format the browser expects, then calls navigator.credentials.create()
      const credential = await create(parseCreationOptionsFromJSON(options));
      console.log("credential from server", credential);

      // 3. Send BOTH pieces of data back to the server
      const payload = {
        attestationResponse: credential.toJSON(),
        originalOptions: options.publicKey // Round-tripping the challenge
      };

      console.log("Payload object",payload)

      // STEP 3: Send the YubiKey response back to C# to verify and save
      return await lastValueFrom(
        this.http.post(this.authURLBase + '/api/FIDO/register-complete?keyName=' + keyname + '&u=' + username, payload)
      );
    } catch (error) {
      console.log("Enrollment Error", error);
      return { success: false, message: 'Enrollment failed', error };
    }
  }

  async login(username: string) {
    // 1. Get options from C#
    const options = await lastValueFrom(
      this.http.post<any>(this.authURLBase + '/api/FIDO/login-options?username=' + username,null)
    );

    // 2. Trigger YubiKey (Browser will prompt "Touch your key")
    const assertion = await get(parseRequestOptionsFromJSON(options));

    // 3. Send back for verification (Stateless round-trip)
    const payload = {
      username: username,
      assertionResponse: assertion.toJSON(),
      originalOptions: options.publicKey // The original challenge
    };

    return await lastValueFrom(
      this.http.post(this.authURLBase + '/api/FIDO/login-complete', payload)
    );
  }

  async getRegisteredKeys(username: string) {
    return await lastValueFrom(
      this.http.get<any>(this.authURLBase + '/api/FIDO/get-registered-keys')
    );
  }

  async deleteKey(keyid: number, hash:string, pin: string, loc: boolean) {
    return await lastValueFrom(
      this.http.get<any>(this.authURLBase + '/api/FIDO/delete-key?key=' + keyid + '&hash=' + encodeURI(hash) + '&pin=' + encodeURI(pin) + '&local=' + loc)
    );
  }
}
